/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable function-paren-newline */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */
import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../shared/components/button/button";
import InputFieldComponent from "../../../shared/components/forms/input-field/input-field";
import InputMultiSelectComponent from "../../../shared/components/forms/multi-select/multi-select-input";
import Navbar from "../../../shared/components/navbar";
import Sidebar from "../../../shared/components/sidebar";
import {
  DetailsTenantProps,
  updateTenantObj,
} from "../../../shared/interfaces/components/detailsTenant.interface";
import { SelectOptions } from "../../../shared/interfaces/components/form.interface";
import { User } from "../../../shared/interfaces/model/user.interface";
import * as actionDeatilTenant from "../../../store/tenant/action";
import { updateTenantRowRequest } from "../../../store/tenant/action";
import * as actionTenantList from "../../../store/tenantUserList/action";
import Card from "../../card/pages/card";
import { Product } from "../../../shared/interfaces/model/product.interface";
import { PaidProductDetails, Tenant } from "../../../shared/interfaces/model/tenant.interface";
import MainLayout from "../../../shared/components/MainLayout";

type ProductMemberDetailsProps = {
  tenant: Tenant;
  currentProduct: PaidProductDetails;
  userList: User[];
}

export const DetailsTenant = (props: DetailsTenantProps) => {
  const dispatch = useDispatch();
  const searchLoc = useLocation().search;
  const tenantId = new URLSearchParams(searchLoc).get("tenantId") ?? "";

  // hook state
  const [tenId, setTenId] = useState(
    window.localStorage.getItem("tenantId") ?? tenantId ?? ""
  );
  const [activeTab, setActiveTab] = useState(0);
  const [product, setProduct] = useState([] as SelectOptions[]);
  const [productString, setProductString] = useState([] as string[]);
  const [products, setProducts] = useState([] as SelectOptions[]);

  const [disabled, setDisabled] = useState(false);
  // destructured reducer state
  const { tenant, detailsTenantIsOk, userList, isUserListOk } = useSelector(
    // @ts-ignore
    (state: any) => ({
      tenant: state.tenantsReducer.detailsTenant,
      detailsTenantIsOk: state.tenantsReducer.detailsTenantIsOk,
      userList: state.tenantUserListReducer.tenantsUserList?.users,
      isUserListOk: state.tenantUserListReducer.isTenantsUserListOk,
    })
  );
  const [organizationName, setOrganizationName] = useState(tenant?.organizationName);
  const [organizationEmail, setOrganizationEmail] = useState(tenant?.organizationEmail);
  const [companyName, setCompanyName] = useState(tenant?.companyName);
  const [VAT, setVAT] = useState(tenant?.VAT);
  const [destinationCode, setDestinationCode] = useState(tenant?.destinationCode);
  const [pec, setPec] = useState(tenant?.pec);
  const [testProducts, setTestProducts] = useState(tenant?.testProducts);

  const isUpdateModeOn: boolean =
    window?.localStorage?.getItem("isUpdateModeOn") === "true";

  React.useEffect(() => {
    const productList: SelectOptions[] = [];
    const productListString: string[] = [];
    const productsFromApi: SelectOptions[] = [];
    setTenId(tenId);
    if (isUpdateModeOn) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }

    if (!detailsTenantIsOk) {
      dispatch(actionDeatilTenant.getDetailsTenantRequest(tenId || ""));
    }

    if (tenId !== "") {
      dispatch(actionTenantList.getTenantUserListRequest(tenId || ""));
    } else {
      dispatch(actionTenantList.getTenantUserListRequest(tenId));
    }

    if (props.productList !== undefined && props.productList.length > 0) {
      props.productList.forEach((element: Product) => {
        productsFromApi.push({ id: element.appCode, value: element.name });
      });
      setProducts(productsFromApi);

      if (Array.isArray(tenant?.product)) {
        tenant.product.forEach((element: string) => {
          const selectedProduct = {
            ...productsFromApi.find((item) => item.id === element),
          };
          productList.push(selectedProduct as SelectOptions);
        });
        setProduct(productList);
        tenant.product.map((elem: string) => productListString.push(elem.toString()));
        setProductString(productListString);
      }
    }

    setOrganizationName(tenant?.organizationName);
    setOrganizationEmail(tenant?.organizationEmail);
    setDestinationCode(tenant?.destinationCode);
    setCompanyName(tenant?.companyName);
    setVAT(tenant?.VAT);
    setPec(tenant?.pec);
    setTestProducts(tenant?.tenantProducts);
    // setOrganizationName(tenant.organizationName);
    // redirect to login page in case of error / missing permissions
    /* if (isUserListOk === false || detailsTenantIsOk === false) {
      props.location("/");
    } */
  }, [
    tenant,
    dispatch,
    props.tenantId,
    detailsTenantIsOk,
    props,
    isUserListOk,
    tenantId,
    tenId,
    isUpdateModeOn,
  ]);

  const handleToggle = (index: number) => {
    setActiveTab((prev) => ((prev === index) ? -1 : index));
  };

  const organizationNameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setOrganizationName(data.target.value);
  };
  const organizationEmailChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setOrganizationEmail(data.target.value);
  };

  const organizationCompanyNameChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setCompanyName(data.target.value);
  };

  const organizationVATChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setVAT(data.target.value);
  };

  const organizationDestinationCodeChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setDestinationCode(data.target.value);
  };

  const organizationPecChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setPec(data.target.value);
  };

  const organizationTestProductsChange = (data: React.ChangeEvent<HTMLInputElement>) => {
    setTestProducts(data.target.value);
  };

  const productsChange = (data: SelectOptions[]) => {
    if (data !== undefined) {
      const lista: string[] = [];
      data.map((item) => lista.push(item.id.toString()));
      setProductString(lista);
      setProduct(data);
    }
  };
  // get details tenant
  const getDetailTenant = (tenaId: string | undefined) => {
    setOrganizationName(tenant.organizationName);
    setOrganizationEmail(tenant.organizationEmail);
    setDestinationCode(tenant.destinationCode);
    setCompanyName(tenant.companyName);
    setVAT(tenant.VAT);
    setPec(tenant.pec);
    dispatch(actionDeatilTenant.getDetailsTenantRequest(tenId || ""));
    // setOrganizationName(tenant.organizationName);
  };

  const updateTenantRow = (updateTenantParam: updateTenantObj) => {
    if (updateTenantParam) {
      dispatch(updateTenantRowRequest(updateTenantParam));
    }
  };

  const fields = [{
    name: "Prodotto",
    id: "productAppName"
  },
  {
    name: "Numero di dipendenti",
    id: "numberEmployees"
  },
  {
    name: "Durata della sottoscrizione",
    id: "payment"
  },
  {
    name: "Versione",
    id: "tier"
  }
  ];

  return (
    <MainLayout>
      <div className="w-full ">
        <div className="container p-2 md:p-10 w-full">
          <div
            className="detailsTenant--wrapper col-xs-12 col-lg-12 py-10"
            data-test="detailsTenant-wrapper"
          >
            <p className="text-2xl font-bold mb-10">
              {disabled ? "Organization Details:" : "Modify Organization:"}
            </p>
            <section>
              <div className="row">
                <div className="col-xs-6">
                  <InputFieldComponent
                    label="Tenant Name:"
                    bold
                    data-test="organization-name"
                    name="organization-name"
                    id="signup-organization"
                    type="text"
                    value={organizationName}
                    title="Inserire campo"
                    disabled={disabled}
                    onChangeHandler={organizationNameChange}
                  />
                </div>
                <div className="col-xs-6">
                  <InputFieldComponent
                    label="Email dell'Organizzazione: "
                    bold
                    data-test="organizationEmail"
                    name="organizationEmail"
                    id="organizationEmail"
                    type="text"
                    value={organizationEmail}
                    title="Inserire campo"
                    disabled={disabled}
                    onChangeHandler={organizationEmailChange}
                  />
                </div>
              </div>
              <h1 className="text-lg font-bold">Prodotti:</h1>
              <section className="rounded border border-solid border-blue-600 p-5 mb-10">
                <div className="flex space-x-4">
                  {tenant?.testProducts?.map((pro: DetailsTenantProps, index: number) => {
                    pro.detailsTenant?.testProducts?.map((pr) => {
                      const isValid = pr.expireDate && new Date(pr.expireDate) > new Date();
                      return isValid ? (
                        <button
                          key={pr.productAppCode}
                          className={`py-2 flex justify-between px-4 border rounded w-full border-blue-600 ${activeTab === index ? 'bg-gray-100' : ''}`}
                          onClick={() => handleToggle(index)}
                        >
                          {pr.productAppName}
                          <span><i className={`fa ${activeTab === index ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden="true" /></span>
                        </button>
                      ) : null;
                    }); return null;
                  })}
                </div>
                <div className="mt-4 ">
                  {tenant?.testProducts?.map((pro: PaidProductDetails, index: number) => (
                    <div key={pro.productAppCode} className={`${activeTab === index && pro.productAppName ? 'block' : 'hidden'} border rounded border-blue-600 p-5`}>

                      <article className="row">
                        {fields.map((field) => (
                          <div key={field.id} className="col-xs-6">
                            <InputFieldComponent
                              label={field.name}
                              bold
                              data-test={field.id}
                              name={field.id}
                              id={field.id}
                              type="text"
                              value={(pro[field.id as keyof Omit<PaidProductDetails, 'invoices'>] ?? '').toString()}
                              title="Inserire campo"
                              disabled
                            />
                          </div>
                        ))}
                      </article>
                      {/* <article className="row">
                        {tenant &&
                          userList && (
                            <ProductMemberDetailsProps
                              tenant={tenant}
                              currentProduct={pro}
                              userList={userList} />
                          )}
                      </article> */}

                    </div>
                  ))}
                </div>
              </section>
            </section>
            {tenant && tenant.id && (
              <div className="row">
                <div className="col-lg-6 col-md-6 col-xs-12">
                  <div className="detailsTenant">
                    <div className="row">
                      <div className="col-xs-6">
                        <InputFieldComponent
                          label="Tenant Name:"
                          bold
                          data-test="organization-name"
                          name="organization-name"
                          id="signup-organization"
                          type="text"
                          value={organizationName}
                          title="Insert field"
                          disabled={disabled}
                          onChangeHandler={organizationNameChange}
                        />
                      </div>
                      <div className="col-xs-6" style={{ display: 'none' }}>
                        <InputMultiSelectComponent
                          label="Prodotti:"
                          bold
                          id="signup-product"
                          options={products}
                          value={product}
                          isSingleSelect={false}
                          placeholder="Seleziona un prodotto"
                          required
                          disabled
                          onMultiSelectChangeHandler={productsChange}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6" style={{ display: 'none' }}>
                        <InputFieldComponent
                          label="Numero di dipendenti:"
                          bold
                          data-test="number_employees"
                          name="number-employees"
                          id="number-employees"
                          type="text"
                          value={tenant.numberEmployees}
                          title="Inserire campo"
                          disabled
                        />
                      </div>
                      <div className="col-xs-6" style={{ display: 'none' }}>
                        <InputFieldComponent
                          label="Durata della sottoscrizione:"
                          bold
                          data-test="subscriptionDuration"
                          name="subscriptionDuration"
                          id="subscriptionDuration"
                          type="text"
                          value={tenant.subscriptionDuration}
                          title="Inserire campo"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="row detailsTenant--underDetail">
                      <div className="col-md-6">
                        <InputFieldComponent
                          label="Email dell'Organizzazione: "
                          bold
                          data-test="organizationEmail"
                          name="organizationEmail"
                          id="organizationEmail"
                          type="text"
                          value={organizationEmail}
                          title="Inserire campo"
                          disabled={disabled}
                          onChangeHandler={organizationEmailChange}
                        />
                      </div>
                      <div className="col-xs-6" style={{ display: 'none' }}>
                        <InputFieldComponent
                          label="Versione: "
                          bold
                          data-test="tier"
                          name="tier"
                          id="tier"
                          type="text"
                          value={tenant.tier}
                          title="Inserire campo"
                          disabled
                        />
                      </div>
                      <div className="col-xs-6">
                        <InputFieldComponent
                          label="Ragiona sociale: "
                          bold
                          data-test="companyName"
                          name="companyName"
                          id="companyName"
                          type="text"
                          value={companyName}
                          title="Inserire campo"
                          disabled={disabled}
                          onChangeHandler={organizationCompanyNameChange}
                        />
                      </div>
                      <div className="col-xs-6">
                        <InputFieldComponent
                          label="P.IVA: "
                          bold
                          data-test="VAT"
                          name="VAT"
                          id="VAT"
                          type="text"
                          value={VAT}
                          title="Inserire campo"
                          disabled={disabled}
                          onChangeHandler={organizationVATChange}
                        />
                      </div>
                      <div className="col-xs-6">
                        <InputFieldComponent
                          label="Codice destinatario: "
                          bold
                          data-test="destinationCode"
                          name="destinationCode"
                          id="destinationCode"
                          type="text"
                          value={destinationCode}
                          title="Inserire campo"
                          disabled={disabled}
                          onChangeHandler={organizationDestinationCodeChange}
                        />
                      </div>
                      <div className="col-xs-6">
                        <InputFieldComponent
                          label="Pec: "
                          bold
                          data-test="pec"
                          name="pec"
                          id="pec"
                          type="text"
                          value={pec}
                          title="Inserire campo"
                          disabled={disabled}
                          onChangeHandler={organizationPecChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    {disabled && (
                      <Button
                        title="Modify Organization"
                        onClickHandler={() => setDisabled(!disabled)}
                      />
                    )}
                    <Link to="/private/tenantlist">
                      <Button
                        title="Indietro"
                        onClickHandler={() => setDisabled(!disabled)}
                      />
                    </Link>
                    {!disabled && (
                      <Button
                        title="SAVE EDIT"
                        onClickHandler={() => {
                          if (tenId) {
                            const upTenant = {
                              id: tenant.id,
                              newOrgName: organizationName,
                              newOrgEmail: organizationEmail,
                              newProduct: productString,
                              newCompanyName: companyName,
                              newDestinationCode: destinationCode,
                              newVAT: VAT,
                              newPec: pec,
                            };
                            updateTenantRow(upTenant);
                          }
                          setDisabled(!disabled);
                        }}
                      />
                    )}
                    {!disabled && (
                      <Button
                        title="CANCEL Modifica"
                        onClickHandler={() => {
                          getDetailTenant(tenId);
                          setDisabled(!disabled);
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-xs-12 ">
                  <div className="row">
                    {userList && isUserListOk && (
                      <div className="col-xs-12 col-md-12 col-sm-12 detailsTenant--users">
                        <Card
                          id="usersCard"
                          tenantDocId={tenant.id}
                          tenantProducts={tenant.product}
                          displayName="Membri"
                          testProducts={tenant.testProducts}
                          userList={[...userList]
                            .filter(
                              (user: User) => user.email === tenant.organizationEmail
                            )
                            .concat(
                              [...userList]
                                .filter(
                                  (user: User) => user.email !== tenant.organizationEmail
                                )
                                .sort((a, b) => (a.email > b.email ? 1 : -1))
                            )}
                          organizationEmail={tenant.organizationEmail}
                        />{" "}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
